import DOMPurify from "dompurify"
import { jsPDF } from 'jspdf';

import logoBlack from '../../image/logo/logoBlack.png'
import { Dispatch, SetStateAction, useEffect, useState} from "react";

export type Menu = MenuContentPage[];
export type Alignment = 'left' | 'center' | 'right' | 'justify';

export interface MenuContentPage {
  elements: MenuElement[]; 
  imgback?: {url:string,iscropp:boolean};
  fontfamilytext?: string;
  fontfamilytitle?: string;
  borderpage?:BorderMenuPage;
}
export const emptyMenuPage:MenuContentPage = {
  elements: [],
}

export type MenuElement = 
  | MenuTitle
  | MenuText
  | MenuSpace
  | MenuImg
  | MenuSeparation;

interface BaseElemProps {
  fontSize?: number;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  alignement?: Alignment;
  fontSizeDesc?: number;
  colorDesc?: string;
  boldDesc?: boolean;
  italicDesc?: boolean;
}
export interface BorderMenuPage {
  color?: string;
  colorline?:string;
  transparent?: boolean;
}

export interface MenuTitle {
  type: 'title';
  props: {
    text: string;
    underline?: boolean;
    style?: number;
  } & BaseElemProps;
}

export interface MenuText {
  type: 'text';
  props: {
    text: string;
    marginLeft?:number,
    marginRight?:number,
    price?: string;
    description?: string;
    visibleDesc?:boolean;
    image?: string; 
  } & BaseElemProps ;
}

export interface MenuSpace {
  type: 'space';
  props: {
    size?: number;
  };
}
export interface MenuSeparation {
  type: 'separation';
  props: {
    height?:number;
    type?:number;
    color?: string;
    alignement?: string;
    width?:number;
    wave?:number;
    degrade?:boolean,
  };
}

export interface MenuImg {
  type: 'img';
  props: {
    url: string;
    width?:number;
    top?:number;
    left?:number;
    border?: number;
    borderColor?:string;
    borderRadius?: number;
    opacity?:number,
  }
}

export function getImgUrlFromBannerContentItem(item:bannerImgBlock|null) {
  if (!item) return null;
  if (typeof item === 'string') return item;    
  if (typeof item === 'object' && typeof item.link === 'string') return item.link;
  return null;
}
export interface bannerImgBlock {
  type: 'img';
  link:string,
}
export interface SeparationBannerResto {
  c:string, //color
  s:number //size
}
export interface LogoBannerResto {
  link:string,
  props?: {
    heightPct?: number;
    radius?:number,
    border?: number;
    borderColor?:string;
    opacity?:number,
  };
}
export interface FilterBannerResto {
  backColor:string,
  opacity:number,
  title?: PageRestoTitle;
  text?: PageRestoText;
}
export interface BasePropsBannerResto {
  separation?:SeparationBannerResto,
  logo?:LogoBannerResto,
  filter?:FilterBannerResto,
}
export type contentBannerResto =
  | ({  v: 1; id: 1; content: bannerImgBlock[];} & BasePropsBannerResto)
  | ({  v: 1; id: 2; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 3; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 4; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 5; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 6; content: bannerImgBlock[] } & BasePropsBannerResto)
  | ({  v: 1; id: 7; content: bannerImgBlock[] } & BasePropsBannerResto);
const emptyBannerImgBlock:bannerImgBlock = {"type":"img","link":""};
export const emptyBannerRestau:contentBannerResto[] = [
    {  v: 1, id: 1, content: [emptyBannerImgBlock]},                     
    {  v: 1, id: 2, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},                       
    {  v: 1, id: 3, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 4, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 5, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 6, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]},
    {  v: 1, id: 7, content: [emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock,emptyBannerImgBlock]}
  ] 

export type TextRun = { t: string; bold?: boolean; italic?: boolean;underLine?: boolean; color?: string; href?: string };

export interface PageRestoTitle {
  fontSize?: number;
  color?: string;
  align?: Alignment;
  runs?:TextRun[];
  lineHeight?:number,
}
  
export interface PageRestoText {
  fontSize?: number;
  color?: string;
  align?: Alignment;
  runs?:TextRun[];
  lineHeight?:number,
}

export interface TextBlock {
  type: 'textblock';
  props: {
    title: PageRestoTitle;
    text: PageRestoText;
  }
}


export interface ImgBlock {
  type: 'img';
  props: {
    link: string;
    radius?: number;
    border?: number;
    borderColor?:string;
    opacity?:number,
    hasInfo?:boolean,
    textInfo?:string
  }
}

export interface SpaceBlock {
  type: 'space';
  props: {
    size?: number;
    height?:number;
    type?:number;
    color?: string;
    alignement?: string;
    width?:number;
    wave?:number;
    degrade?:boolean,
  };
  backColor?:string
}
export interface BaseFontFamiliyBlockProps {
  fonttitle?:string; 
  fonttext?:string;
  alignTop?:boolean,
  margeTop?:number,
  margeBottom?:number,
  backColor?:string
}
export interface VideoBlock {
  type: 'video';
  props: {
    linkFacebook: string;
    linkInsta: string;
    linkCurrent:string;
    chooseFacebook: boolean;
    reverse?:boolean;
  }
}
export type contentBlockRestau =
  | ({ id: 1; content: [TextBlock] } & BaseFontFamiliyBlockProps)
  | ({ id: 2; content: [ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 3; content: [ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 4; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 5; content: [ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 6; content: [TextBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 7; content: [ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 8; content: [TextBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 9; content: [ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 10; content: [ImgBlock, TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 11; content: [ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 12; content: [ImgBlock, TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 13; content: [ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 14; content: [TextBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 15; content: [ImgBlock, ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 16; content: [TextBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 17; content: [ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 18; content: [ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 19; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 20; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 21; content: [VideoBlock, TextBlock]} & BaseFontFamiliyBlockProps)
  | ({ id: 22; content: [ImgBlock, ImgBlock, ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 23; content: [TextBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 24; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 25; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 26; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock,ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 27; content: [ImgBlock, ImgBlock, ImgBlock, ImgBlock,ImgBlock,ImgBlock,ImgBlock] } & BaseFontFamiliyBlockProps )
  | ({ id: 28; content: [ImgBlock,TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 29; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 30; content: [ImgBlock, TextBlock] } & BaseFontFamiliyBlockProps  )
  | ({ id: 31; content: [TextBlock, ImgBlock] } & BaseFontFamiliyBlockProps );
const emptyTextBlock:TextBlock = {"type":"textblock",props:{
  "title":{"runs":[{"t":''}]},"text":{"runs":[{"t":''}]}
}};
const emptyImgBlock:ImgBlock = {"type":"img",props:{"link":""}};
export const emptySpaceBlock:SpaceBlock = {"type":"space",props:{}};
const emptyVideoBlock:VideoBlock =   {"type" : 'video',props: {linkFacebook: '',linkInsta: '',linkCurrent:'',chooseFacebook:false}};

export const emptyBlockRestau:contentBlockRestau[] = [
    { id: 1, content: [emptyTextBlock] },                     
    { id: 2, content: [emptyImgBlock] },                       
    { id: 3, content: [emptyImgBlock] },                         
    { id: 4, content: [emptyTextBlock, emptyImgBlock] },            
    { id: 5, content: [emptyImgBlock, emptyTextBlock] },
    { id: 6, content: [emptyTextBlock, emptyTextBlock] }, 
    { id: 7, content: [emptyImgBlock, emptyImgBlock] },     
    { id: 8, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock] },     
    { id: 9, content: [emptyImgBlock, emptyImgBlock, emptyTextBlock] }, 
    { id: 10, content: [emptyImgBlock,emptyTextBlock, emptyImgBlock] },   
    { id: 11, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 12, content: [emptyImgBlock, emptyTextBlock, emptyImgBlock] }, 
    { id: 13, content: [emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 14, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock] },
    { id: 15, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 16, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 17, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 18, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 19, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 20, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 21, content: [emptyVideoBlock, emptyTextBlock] },
    { id: 22, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyTextBlock] },
    { id: 23, content: [emptyTextBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 24, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 25, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock] },
    { id: 26, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock] },
    { id: 27, content: [emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock, emptyImgBlock,emptyImgBlock] },
    { id: 28, content: [ emptyImgBlock, emptyTextBlock] },            
    { id: 29, content: [emptyTextBlock, emptyImgBlock] },
    { id: 30, content: [emptyImgBlock, emptyTextBlock] }, 
    { id: 31, content: [emptyTextBlock, emptyImgBlock] }, 
  ];

export const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%*/^\.])[A-Za-z\d!@#$%*/^\.]{8,}$/;
export const plageHours = [
  '00h00', '00h15', '00h30', '00h45',
  '01h00', '01h15', '01h30', '01h45',
  '02h00', '02h15', '02h30', '02h45',
  '03h00', '03h15', '03h30', '03h45',
  '04h00', '04h15', '04h30', '04h45',
  '05h00', '05h15', '05h30', '05h45',
  '06h00', '06h15', '06h30', '06h45',
  '07h00', '07h15', '07h30', '07h45',
  '08h00', '08h15', '08h30', '08h45',
  '09h00', '09h15', '09h30', '09h45',
  '10h00', '10h15', '10h30', '10h45',
  '11h00', '11h15', '11h30', '11h45',
  '12h00', '12h15', '12h30', '12h45',
  '13h00', '13h15', '13h30', '13h45',
  '14h00', '14h15', '14h30', '14h45',
  '15h00', '15h15', '15h30', '15h45',
  '16h00', '16h15', '16h30', '16h45',
  '17h00', '17h15', '17h30', '17h45',
  '18h00', '18h15', '18h30', '18h45',
  '19h00', '19h15', '19h30', '19h45',
  '20h00', '20h15', '20h30', '20h45',
  '21h00', '21h15', '21h30', '21h45',
  '22h00', '22h15', '22h30', '22h45',
  '23h00', '23h15', '23h30', '23h45',
  '00h00'
];
export const baseDays = ["Dimanche","Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", ];

export const baseGenre =['M.','Mme','Autre']


export type typeSpecialDate = { [key: string]: [boolean,[string, string][]] }
export type typeSchedule = { [key: string]: [[string, string],[string,string]] | string }

export const isBetween = (start:string,end:string,hour:string) => {
    let idStart = plageHours.findIndex(h => h === start);
    idStart =  idStart === 0 ? 95 : idStart-1;
    const idEnd = plageHours.findIndex(h => h === end);
    const idHour = plageHours.findIndex(h => h === hour);
    if(idStart < idEnd) {
        return idStart <= idHour && idHour <= idEnd
    }
    else {
        return idStart <= idHour || idHour <= idEnd
    }
}
export const formatDateToYMD = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}-${month}-${year}`;
};
export interface ReviewProps {
    idavis:number,
    iduser:number,
    title: string,
    text: string,    
    note:number,
    note_detail?:[number,number,number],
    verif:boolean,
    visible:boolean,
    firstname: string, 
    photo: string,   
    nameR?: string,
    photoR?:string,
    user_grade: number,
    post_date:Date,
    response?:string, 
    post_date_response?:Date,
    idrestaurant?:number,
}

export interface ReviewPageProfilProps {
    idavis:number,
    title: string,
    text: string,  
    user_grade: number,  
    note:number,
    response?:string,
    post_date_response?:Date,
    post_date:Date,
    note_detail?:[number,number,number],
    idrestaurant:number,
    verif:boolean,
    restaurateur_img: string,  
    restaurant_name:string, 
    restaurant_devanture:string,
    restaurant_address:[string,string],
    restaurant_idurl:string,
}
export interface Point {
    type: string; 
    coordinates: [number, number]; 
}
export interface Restaurant {
    idrestaurant: number; 
    id_url:string,
    name: string;     
    devanture: string; 
    listimg?: string[];  
    note: number;     
    filters?: string[];  
    location: Point;
    type:string[];
    schedule: typeSchedule;
    special_date?: typeSpecialDate;
    date_published?:Date;
    nbr_review:number,
    address:[string,string],
    phone:string,
    price:[number,number]
    biography?:string;
    total_price:number,
    cuisines:[string,string],
    visiblecity:string,
    score:number,
    date_update:Date,
    is_resa_phone:boolean,
    address_hint?:string,
}
export interface Location {
  lat: number; 
  lng: number; 
  name: string;
  idrestaurant:number;
  is_resa_phone:boolean,
  nbr_review:number,
  filters?:string[],
  devanture:string;
  type:string[];
  note:number;
  id_url:string;
  address:[string,string];
  phone:string;
  listImg?:string[];
  biography?:string;
  schedule: typeSchedule;
  special_date?: typeSpecialDate;
  total_price:number,
  cuisines:[string,string],
  date_update:Date,
  address_hint?:string,
}
export interface RestoFavProps {
    id_url:string,
    idrestaurant:number,
    address:[string,string];
    devanture:string,
    name:string,
    note:number,
    nbr_review:number,
}

export interface SubscribeProps {
    id:number,
    name:string,
    firstname:string,
    photo:string,
    nbr_review:number,
}

export interface Coordonates {
    latitude: string,
    longitude: string,
}
export const ListGrades: string[] = ['Novice','Apprenti Culinaire','Explorateur Culinaire','Maitre Culinaire','Elite Culinaire']

export const TypeResto: string[]  = ["Restaurant Traditionnel", "Brasserie", "Bistrot", "Restaurant Bistronomique", "Restaurant Gastronomique", "Restaurant à Thème", "Crêperie", "Pizzeria", "Restaurant à Volonté", "Auberge-Restaurant", "Hôtel-Restaurant", "Bar-Restaurant", "Restaurant Ouvrier", "Guinguette"
]

export const compatibilitesType:{ [key: string]: [string[],string[]] } = {
    "Auberge-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Historiquement, les auberges accueillaient les voyageurs en quête de repos et de bonne cuisine.",
      "Aujourd’hui, elles perpétuent cet esprit en mettant à l’honneur les produits locaux à travers une cuisine généreuse et authentique.",
      "Servie dans un cadre rustique, où le charme d’antan se mêle à l’authenticité du lieu et à un accueil sincère."
    ]],
    "Hôtel-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Un hôtel-restaurant, c’est un établissement qui réunit restauration et hébergement sous une même enseigne.",
      "Ils accordent de l'importance à l’atmosphère du lieu et à l’assiette, en proposant des cuisines variées, allant des saveurs traditionnelles aux créations gastronomiques.",
      "Chaque établissement a son identité propre, mais tous partagent le même sens de l’accueil et du service."
    ]],
    "Bar-Restaurant": [[" Traditionnel", " Bistronomique", " Gastronomique", " Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les bar-restaurants sont des bars qui proposent une offre de restauration, on y vient autant pour l’ambiance que pour la table.",
      "L’atmosphère y est essentielle, portée par le rythme du service et l’énergie du lieu, où l’on profite d’un repas aussi facilement que d’un verre entre amis.",
      "Chaque établissement a son propre caractère, mais tous cultivent le même esprit de convivialité."
    ]],
    "Restaurant Ouvrier": [[" et Traditionnel", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les restaurants ouvriers accueillent généralement les artisans et les travailleurs venus chercher un repas généreux et abordable.",
      "On y sert une cuisine simple et nourrissante, avec un service rapide et sans détour.",
      "Un restaurant où l’on mange bien, dans une ambiance franche et authentique."
    ]],
    "Restaurant à Thème": [[" et Traditionnel", " et Bistronomique", " et Gastronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " et à Volonté"], [
      "Un restaurant à thème est une expérience culinaire centrée sur un produit, un plat ou un savoir-faire.",
      "Ici, tout tourne autour d’un fil conducteur : une déclinaison du même univers où chaque plat explore une facette différente du thème."
    ]],
    "Restaurant Traditionnel": [[" et Bistronomique", " et Gastronomique", " et Bistrot", " et Brasserie", " et Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les restaurants traditionnels sont les gardiens du patrimoine culinaire régional.",
      "La cuisine y est faite maison, généralement avec des produits de saison et des plats inspirés du terroir. C’est ici que l’on retrouve l’essence même du restaurant : un lieu pour partager un bon repas où l’on prend le temps d’apprécier l’instant, tout simplement."
    ]],
    "Guinguette": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté"], [
      "Les guinguettes, souvent aux bords de l’eau, sont des lieux animés et de partage en plein air.",
      "Ouvertes en saison estivale, on y déguste une cuisine savoureuse, entre musique, rires et moments partagés.",
      "Un lieu vivant, où le plaisir de la table se mêle à la joie d’être ensemble, dans une ambiance conviviale et festive, fidèle à l’esprit de QuelResto."
    ]],
    "Bistrot": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les bistrots sont des restaurants aux cadres vivants et atypiques, dans des ambiances chaleureuses et décontractées.",
      "On y déguste souvent une cuisine simple, inspirée des recettes traditionnelles.",
      "Que ce soit pour un repas convivial ou simplement pour boire un café, les bistrots sont des lieux où l’on aime se retrouver."
    ]],
    "Brasserie": [[" et Restaurant Traditionnel", " et Restaurant Bistronomique", " et Restaurant Gastronomique", " et Bistrot", " et Restaurant Ouvrier", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les brasseries sont des lieux dynamiques, où l’énergie et la convivialité se mêlent à une cuisine généreuse et accessible.",
      "Héritières du brassage de la bière et souvent ouvertes toute la journée, elles proposent une carte variée dans une ambiance animée."
    ]],
    "Restaurant Bistronomique": [[" et Traditionnel", " et Gastronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Un restaurant bistronomique, c’est la rencontre entre la générosité du bistrot et l’exigence de la gastronomie.",
      "On y retrouve l’authenticité d’un bistrot, avec un service détendu, mais chaque assiette raconte une histoire grâce à des saveurs audacieuses et des produits sublimés par des techniques de haute cuisine."
    ]],
    "Restaurant Gastronomique": [[" et Traditionnel", " et Bistronomique", " et Bistrot", " et Brasserie", " et Crêperie", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Un restaurant gastronomique, c’est l’exploration du goût poussée à son plus haut niveau.",
      "Ici, chaque plat est une œuvre, où la technique et la créativité se mélangent pour éveiller les sens.",
      "On ne se contente pas de manger, on découvre, on ressent, on s’émerveille."
    ]],
    "Crêperie": [[" Traditionnelle", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Pizzeria", " à Thème", " à Volonté", " et Guinguette"], [
      "Les crêperies sont des lieux où la tradition se mêle à la créativité.",
      "Qu’elles perpétuent l’héritage breton ou revisitent les classiques, on y déguste galettes et crêpes aux saveurs infinies.",
      "Ce sont des restaurants où l’on aime se retrouver, portés par une ambiance vivante et le plaisir d’un repas partagé."
    ]],
    "Pizzeria": [[" Traditionnelle", " Bistronomique", " Gastronomique", " et Bistrot", " et Brasserie", " et Restaurant Ouvrier", " et Crêperie", " à Thème", " à Volonté", " et Guinguette"], [
      "Nées en Italie, les pizzerias sont le symbole d’une cuisine simple et populaire.",
      "Que ce soit dans une petite adresse de quartier ou une enseigne animée, elles partagent le même savoir-faire : une pâte travaillée avec soin, une cuisson maîtrisée et une carte qui décline la pizza sous toutes ses formes.",
      "Plus qu’un repas, c’est un moment vivant et chaleureux, où la simplicité rime avec plaisir."
    ]],
    "Restaurant à Volonté": [[" à Thème"], [
      "Les restaurants à volonté offrent un large choix de plats, pour ceux qui cherchent à manger à leur faim sans se limiter.",
      "Dans un cadre décontracté, on y trouve des buffets ou des plats en libre-service, pour satisfaire toutes les envies, à tout moment.",
      "Un lieu où l’on se sert à sa guise, pour manger à sa faim et savourer chaque bouchée sans contrainte."
    ]],
  }
  
  

export const extractSecondType = (type: string) => {
  const words = type.trim().split(/\s+/);
  return words.length > 1 ? words.slice(1).join(" ") : words[0];
};
export const extractLastWord = (type: string) => {
  const words = type.trim().split(/\s+/);  
  return words[words.length - 1];  
};


export async function fetchWithRefreshUser(url: string, options: RequestInit) {
    let response = await fetch(url, options);

    if (response.status === 401) { 
        const refreshResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenUser`, {
            method: 'POST',
            credentials: 'include'
        });
        if (refreshResponse.ok) {
            const data = await refreshResponse.json();
            localStorage.setItem('token', data.accessToken); 
            await new Promise(resolve => setTimeout(resolve, 100));
            response = await fetch(url, {
                ...options,
                headers: {
                    ...options.headers,
                    'Authorization': `Bearer ${data.accessToken}`, 
                },
            });
        } else {
            console.error('Erreur lors du rafraîchissement du token');
            return;
        }
    }

    return response;
}
function isImpersonationRestau() {
  return sessionStorage.getItem("impersonation") === "1";
}
export async function fetchWithRefreshRestau(url: string, options: RequestInit) {
    const impersonation = isImpersonationRestau();
    const headers = new Headers(options.headers || {});
    options.headers = headers;
    if (impersonation) {
      const token = sessionStorage.getItem("restau_access");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      } else {
        console.warn("Impersonation active mais restau_access absent en sessionStorage");
      }
    } else {
      if (!headers.has("Authorization")) {
        const token = localStorage.getItem("token");
        if (token) headers.set("Authorization", `Bearer ${token}`);
      }
    }

    let response = await fetch(url, options);
    if (response.status === 401 || response.status === 403) { 
        const refreshResponse = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/tokenRestau`, {
            method: 'POST',
            credentials: 'include'
        });
        if (refreshResponse.ok) {
            const data = await refreshResponse.json();
            localStorage.setItem('token', data.accessToken); 
            await new Promise(resolve => setTimeout(resolve, 100));
            if (!options.headers) {
                options.headers = new Headers();
            }
            if (options.headers instanceof Headers) {
                options.headers.set('Authorization', `Bearer ${data.accessToken}`);
            } else {
                const headers = new Headers(options.headers);
                headers.set('Authorization', `Bearer ${data.accessToken}`);
                options.headers = headers; 
            }
            response = await fetch(url, options);
        } else {
            console.error('Erreur lors du rafraîchissement du token');
            return;
        }
    }
    return response;
}

export const formatPhoneNumber = (value: string) => {
        const cleaned = value.replace(/\D+/g, '');
        return cleaned.replace(/(\d{2})(?=\d)/g, '$1 ');
};

export const  createImage = (url: string) =>
    new Promise<HTMLImageElement>((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.src = url;
});

export const getCroppedImg = async (imageSrc: string, crop: any,isBanner=false) => {
    const image: any = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const { width: naturalWidth, height: naturalHeight } = image;
    const scaleX = naturalWidth / image.width;
    const scaleY = naturalHeight / image.height;

    const croppedWidth = crop.width * scaleX;
    const croppedHeight = crop.height * scaleY;

    const MAX_SIDE = isBanner ? 2560 : 1920;
    const scaleDown = Math.min(1, MAX_SIDE / Math.max(croppedWidth, croppedHeight));
    const outW = Math.max(1, Math.round(croppedWidth * scaleDown));
    const outH = Math.max(1, Math.round(croppedHeight * scaleDown));

    canvas.width = outW;
    canvas.height = outH;

    ctx?.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      croppedWidth,
      croppedHeight,
      0,
      0,
      canvas.width,
      canvas.height
    );
    const originalSizeInKB = Math.ceil((imageSrc.length * (3 / 4)) / 1024);


    let quality = isBanner ? 0.93 : 0.8; 
    if (originalSizeInKB > 3000 && !isBanner) {
        quality = 0.4; 
    } else if (originalSizeInKB > 1000 && !isBanner) {
        quality = 0.6;
    } 
    return canvas.toDataURL(`image/webp`,quality);
  };
export const leaveInputEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "Enter") {
    e.currentTarget.blur(); 
  }
};
  
export interface FilterItem {
    value: string;
    liste?: string[] ;
}

export type typeDailyMenu = {image:string,dates:Date[]}
export const TypeMeal = ["Brunch", "Déjeuner", "Dîner","Buffet"]
export const PerfectFor = ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']
export const allShowFilter = ['Notes','Prix par personne','Distance']
export const principalCuisine = ['Française','Italienne','Espagnole','Japonaise','Chinoise','Coréenne','Portugaise']
export const listCuisine: string[] = [
  "Afghane","Africaine", "Albanaise", "Algérienne", "Allemande", "Américaine", "Andorrane", "Angolaise", 
  "Antiguayenne", "Argentine", "Asiatique", "Australienne", "Autrichienne", "Bahaméenne", "Bangladaise", "Barbadienne", 
  "Belge", "Belizienne", "Béninoise", "Biélorusse", "Birmane", "Bolivienne", "Bosnienne", "Botswanaise", 
  "Brésilienne", "Britannique", "Bulgare", "Burkinabè", "Burundaise", "Cambodgienne", "Camerounaise", 
  "Canadienne", "Cap-Verdienne", "Centrafricaine", "Chilienne", "Chinoise", "Christophienne", "Chypriote", 
  "Colombienne", "Comorienne", "Congolaise", "Coréenne", "Costaricienne","Créole", "Croate", "Cubaine", "Danoise", 
  "Djiboutienne", "Dominicaine", "Égyptienne", "Équatorienne", "Espagnole", "Estonienne", "Eswatinienne", "Éthiopienne", 
  "Finlandaise", "Française", "Fidjienne", "Gabonaise", "Gambienne","Géorgienne", "Ghanéenne", "Grecque", "Grenadienne", 
  "Guatémaltèque", "Guinéenne", "Guinéenne-Bissau", "Guyanaise", "Haïtienne", "Hondurienne", "Hongroise", 
  "Indienne", "Indonésienne", "Irakienne", "Iranienne", "Irlandaise", "Islandaise", "Italienne", "Ivoirienne", "Jamaïcaine", 
  "Japonaise", "Kazakhe", "Kenyaéenne", "Kiribatienne", "Kosovare", "Laotienne", "Lettone", "Libanaise", 
  "Libérienne", "Libyenne", "Liechtensteinoise", "Lituanienne", "Luxembourgeoise", "Macédonienne", 
  "Malaisienne", "Malawienne", "Maltaise", "Malgache", "Malienne", "Marocaine", "Marshallienne", 
  "Mauricienne", "Mauritanienne", "Mexicaine", "Moldave", "Monégasque", "Mongole", "Monténégrine", 
  "Mozambicaine", "Namibienne", "Nauruane", "Néo-zélandaise", "Nicaraguayenne", "Nigériane", "Norvégienne", 
  "Ougandaise", "Ouzbèke", "Pakistanaise", "Palaosienne", "Panaméenne", "Papouasienne", "Paraguayenne", 
  "Péruvienne", "Philippine", "Polonaise", "Portugaise", "Réunionnaise", "Roumaine", "Russe", "Rwandaise", 
  "Salomonaise", "Samoane", "Santoméenne", "Saoudienne", "Sénégalaise", "Serbe", "Seychelloise", 
  "Sierra-Léonaise", "Singapourienne", "Slovaque", "Slovène", "Somalienne", "Sri-Lankaise", "Sud-africaine", 
  "Suédoise", "Suisse", "Surinamaise","Syrienne", "Tanzanienne", "Tchadienne", "Tchèque", "Thaïlandaise", 
  "Tibétaine", "Togolaise", "Tongienne", "Trinidadienne", "Tunisienne", "Turque", "Tuvaluane", "Ukrainienne", 
  "Uruguayenne", "Vanuatienne", "Vaticane", "Vénézuélienne", "Vietnamienne", "Zambienne", "Zimbabwéenne"
];
export const listFilters: FilterItem[] = [
  {value:'Raccourci', liste:['A proximité','Ouvert ce midi', 'Ouvert ce soir']},
    {value: "Type de restaurant", liste: TypeResto},
    {value: 'Origine de la cuisine', liste: listCuisine},
    {value:'Moyen de paiement', liste:['Carte bancaire', 'American Express','Carte ticket restaurant' ,'Ticket restaurant', 'Chèques','Chèque-vacances','Espèces']},
    {value:'Prix par personne'},
    {value:'Distance'},
    {value:'Idéal pour', liste: ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']},
    {value:'Ambiance et expérience', liste:['Concept unique', 'Vue exceptionnelle', 'Lieu historique','Spécialités locales','Calme','Nature','Centre-ville','Bord de l’eau','Rooftop','Restaurant immersif','Restaurant éphémère','Restaurant spectacle']},
    {value:'Régime alimentaire', liste:['Végétarien','Végan','Sans gluten','Sans lactose','Halal','Kasher ']},
    {value:'Options pratiques', liste:['Menu ouvrier','Ingrédients de saisons','Événement','Privatisable','Bons cadeaux','Service en continu','Animaux autorisés','Terrasse extérieure','Terrasse couverte','Terrasse ombragée','Espace business','Wifi disponible']},
    {value:'Parking', liste:['Stationnement facile','Parking à proximité','Parking gratuit','Parking couvert','Parking privé','Borne de recharge','Parking PMR']},
    {value:'Notes',liste: ['5 étoiles','4 étoiles', '3 étoiles']},
    {value:'Accessibilités', liste:['Accès PMR','Toilettes PMR','Equipe formée LSF','Adapté aux poussettes','Table à langer']},
]
export const listFiltersResto: FilterItem[] = [
  {value:'Moyen de paiement', liste:['Carte bancaire', 'American Express', 'Carte ticket restaurant' , 'Ticket restaurant', 'Chèques','Chèque-vacances','Espèces']},
  {value:'Idéal pour', liste: ['En famille','En famille avec enfants','En couple','Entre amis','Avec soi-même','Repas d’affaires','Grandes occasions']},
  {value:'Ambiance et expérience', liste:['Concept unique', 'Vue exceptionnelle', 'Lieu historique','Spécialités locales','Calme','Nature','Centre-ville','Bord de l’eau','Rooftop','Restaurant immersif','Restaurant éphémère','Restaurant spectacle']},
  {value:'Régime alimentaire', liste:['Végétarien','Végan','Sans gluten','Sans lactose','Halal','Kasher ']},
  {value:'Options pratiques', liste:['Menu ouvrier','Ingrédients de saisons','Événement','Privatisable','Bons cadeaux','Service en continu','Animaux autorisés','Terrasse extérieure','Terrasse couverte','Terrasse ombragée','Espace business','Wifi disponible']},
  {value:'Parking', liste:['Stationnement facile','Parking à proximité','Parking gratuit','Parking couvert','Parking privé','Borne de recharge','Parking PMR']},
  {value:'Accessibilités', liste:['Accès PMR','Toilettes PMR','Equipe formée LSF','Adapté aux poussettes','Table à langer']},
]

export type InformationProfilRestau =  [string,string,string,boolean,string,string]
export type InformationResto =  [string[],string,number,[string,string],string,string]


export const getPurifyMail = (email:string) => {
    let cleanMail = DOMPurify.sanitize(email);
    let [localPart, domainPart] = cleanMail.split('@');
    if (localPart && domainPart) {
        cleanMail = `${localPart.toLowerCase()}@${domainPart}`;
    }
    cleanMail = cleanMail.toLocaleLowerCase();
    cleanMail = cleanMail.replace(/\s/g, '');
    return cleanMail;
}

export type CommandProps = [string,number,string,number,Date[],number,number]

export interface ValuesInvoices {
    post_date: Date,
    ref:string,
    company_name: string,
    address:string,
    payment_methode:string,
    command:CommandProps[],
    nbrbilling:string,
    city:string,
    zipcode:string,
    before_payment:boolean,
    refabo?:string,
    id?:number,
}


export const generatePDF = (data: ValuesInvoices, refAbo:string,isPost:boolean=true) => {
    const doc = new jsPDF();
    let amountHT = 0;
    let finalAmountHT = 0;
    let amountDiscountHT = 0;
    for(const elem of data.command) {
        amountHT += elem[1]*elem[5];
        amountDiscountHT += elem[3] ? elem[3]*(elem[6]||1) : 0;
    }
    finalAmountHT = amountHT - amountDiscountHT;

    const taxe = finalAmountHT*0.2;
    let finalAmount = (finalAmountHT+taxe).toFixed(2);
    const isProduction = window.location.origin.startsWith("https://www.quelresto.fr");

    const marginLeft = 15;

    doc.addImage(logoBlack, 'WEBP', marginLeft, 10, 45, 13);
  
  

    doc.setLineWidth(0.3);
    doc.setFontSize(22);

    doc.setFont("helvetica", "bold");
    if(isPost) doc.text("FACTURE", 195, 20, { align: "right" });
    else doc.text("Aperçu avant émission", 195, 20, { align: "right" });
  
    doc.setFontSize(10);
    doc.text("Date d’émission :", marginLeft, 42);
    doc.text("FACTURE N° : ", 160, 42, { align: "right" });
    if (!isProduction) {
      doc.setFontSize(80);
      doc.setTextColor(179, 179, 179)
      doc.text("FACTURE TEST", 20, 30,{angle: -45});
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0)
    }

    
    doc.text("QUELRESTO", marginLeft, 55);
    doc.text("SIRET : ", marginLeft, 60);

    doc.text("Email : ", marginLeft, 65);

    doc.text("CLIENT :", 195, 55, { align: "right" });

    doc.text("Description :", marginLeft, 87);
    doc.text("Date :", 105, 87,{ align: "right" });
    doc.text("Quantité :", 132, 87,{ align: "right" });
    doc.text("Prix Unitaire HT :", 172, 87,{ align: "right" });
    doc.text("Total HT :", 195, 87, { align: "right" });
    
    const dateInvoice = new Date(data.post_date).toLocaleDateString()
    
    
    doc.setFont("helvetica", "normal");
    doc.text(dateInvoice, marginLeft + 30, 42);
    doc.text(data.nbrbilling, 195, 42, { align: "right" });
    doc.text("939 502 464 00018", marginLeft + 14, 60);

    doc.text("service-client@quelresto.fr", marginLeft + 13, 65);
    doc.text(data.company_name, 195, 60, { align: "right" });
    doc.text(data.address, 195, 65, { align: "right" });
    doc.text(data.address, 195, 65, { align: "right" });
    doc.text(`${data.zipcode}, ${data.city}`, 195, 70, { align: "right" });
    doc.text(`Référence client : ${refAbo}`, 195, 75, { align: "right" });


    let currentY = 95;
    for(const elem of data.command) {
        if(elem[4] && elem[4].length > 0) {
            if(elem[4].length === 1) {
              doc.text(`${new Date(elem[4][0]).toLocaleDateString('fr-FR')}`, 105, currentY,{ align: "right" });  
            } else {
              doc.text(`du ${new Date(elem[4][0]).toLocaleDateString('fr-FR')}`, 105, currentY,{ align: "right" });
              doc.text(`au ${new Date(elem[4][1]).toLocaleDateString('fr-FR')}`, 105, currentY+5,{ align: "right" });
            }
        }
        else doc.text(`${new Date(data.post_date).toLocaleDateString('fr-FR')}`, 105, currentY,{ align: "right" }); 
        
        doc.text(elem[0], marginLeft, currentY,{ maxWidth: 70 });
        

        doc.text(elem[5].toFixed(2) || '1,00', 132, currentY,{ align: "right" });
        doc.text(`${elem[1].toFixed(2).toString()} €`, 172, currentY,{ align: "right" });
        doc.text(`${(elem[1]*elem[5]).toFixed(2).toString()} €`, 195, currentY, { align: "right" });

        if(elem[2] && elem[2]!== "") {
            currentY += 7;
            if (elem[4] && elem[4].length > 1){currentY += 2;}
            doc.text(`${elem[2]}`, marginLeft, currentY,{ maxWidth: 70 });
            doc.text((elem[6] || 1).toFixed(2) || '1,00', 132, currentY,{ align: "right" });
            doc.text(`- ${elem[3].toFixed(2).toString()} €`, 172, currentY, { align: "right" });
            doc.text(`- ${(elem[3]*(elem[6]||1)).toFixed(2).toString()} €`, 195, currentY, { align: "right" });
        }
        else if (elem[4] && elem[4].length > 1) {currentY += 5;}
        currentY += 5;
        if(elem[0] && elem[0].length > 40) currentY += 3;

        doc.setDrawColor(120);
        doc.line(15, currentY, 195, currentY);
        currentY += 7;
    }
    currentY += 4;
    doc.setFont("helvetica", "normal");
    doc.text("Total HT :", 175, currentY,{ align: "right" });

    doc.text(` ${amountHT.toFixed(2)} €`, 195, currentY,{ align: "right" });
    currentY += 6;

    if(amountDiscountHT > 0 ) {
        doc.setFont("helvetica", "normal");
        doc.text("Total remise :", 175, currentY,{ align: "right" });
        doc.text(` ${amountDiscountHT.toFixed(2)} €`, 195, currentY,{ align: "right" });

        currentY += 6;
        doc.setFont("helvetica", "bold");
        doc.text("Total HT après remise :", 175, currentY,{ align: "right" });
        doc.text(` ${finalAmountHT.toFixed(2)} €`, 195, currentY,{ align: "right" });
        currentY += 6;
    }

    doc.setFont("helvetica", "normal");
    doc.text("TVA 20% :", 175, currentY,{ align: "right" });
    
    doc.text(` ${taxe.toFixed(2)} €`, 195, currentY,{ align: "right" });
    currentY += 6;
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL TTC :", 175, currentY,{ align: "right" });
    doc.text(`${finalAmount} €`, 195, currentY, { align: "right" });
    currentY += 6;

    if(data.before_payment) {
      const dateMaxPayment = new Date(new Date(data.post_date).getTime() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString('fr-FR');
      currentY = 204
      const pageWidth = doc.internal.pageSize.getWidth();
      const tableSpacing = 15; 
      const table1Width = pageWidth * 0.40;
      const table2Width = pageWidth * 0.38;
      const tableHeight = 28; 


      const x1 = marginLeft;
      const y1 = currentY;


      doc.setDrawColor(80,80,80);
      doc.setFontSize(9);
      doc.rect(x1, y1, table1Width, tableHeight);
      doc.setFillColor(236,236,236);
      const rowHeight = 7;
      doc.rect(x1, y1, table1Width, rowHeight, "F");
      doc.rect(x1, y1, table1Width, rowHeight);
      doc.text("Coordonnées bancaires", x1 + 2, y1 + rowHeight / 2 + 1);
      const labels = ["Titulaire", "IBAN", "BIC"];
      const texts = ["S.A.R.L. QUELRESTO", "FR7617906000329643396373022", "AGRIFRPP879"];
      const colWidth = table1Width / 5;
      const colWidth2 = table2Width / 4;
      for (let i = 0; i < 3; i++) {
        const rowY = y1 + rowHeight + i * rowHeight;

        doc.setFillColor(236,236,236);
        doc.rect(x1, rowY, colWidth, rowHeight, "F");
        doc.rect(x1, rowY, table1Width, rowHeight); 
        doc.rect(x1, rowY, colWidth, rowHeight);

        doc.setFont("helvetica", "normal");
        doc.text(labels[i], x1 + 2, rowY + rowHeight / 2 +1);

        
        doc.text(texts[i], x1 + colWidth + 2, rowY + rowHeight / 2+1);
      }

      const x2 = x1 + table1Width + tableSpacing;
      let y2 = currentY+14;
      doc.setFillColor(236,236,236);
      doc.rect(x2, y2, table2Width, 14);

      doc.rect(x2, y2, table2Width, rowHeight, "F");
      doc.rect(x2, y2, table2Width, rowHeight);
      doc.setFont("helvetica", "bold");
      doc.text("Règlement par virement bancaire sous 14 jours", x2 + 2, y2 + rowHeight / 2 + 1);

      y2 += 7;
      doc.setFillColor(236,236,236);
      doc.rect(x2, y2, colWidth2, rowHeight, "F");
      doc.rect(x2, y2, table2Width, rowHeight);
      doc.rect(x2, y2, colWidth2, rowHeight);
      doc.setFont("helvetica", "normal");
      doc.text("Échéance", x2 + 2, y2 + rowHeight / 2 + 1);

      doc.text(`${finalAmount} € au ${dateMaxPayment}`, x2 + colWidth2 + 2, y2 + rowHeight / 2 + 1);

    }


    currentY = 244;
    doc.setFont("helvetica", "bold");
    doc.text("MODALITÉS DE RÈGLEMENT :", marginLeft, currentY);
    currentY += 6;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("Paiement effectué par carte bancaire via la plateforme sécurisée Up2Pay.", marginLeft, currentY);
    currentY += 4;
    doc.text("Pour les abonnements : débit automatique autorisé par le client lors de la création de son compte.", marginLeft, currentY);
    currentY += 4;
    doc.text("Pour les forfaits : débit autorisé par le client sur sa carte enregistrée ou règlement par virement bancaire.", marginLeft, currentY);
    currentY += 4;
    doc.text("Pas d'escompte en cas de paiement anticipé.", marginLeft, currentY);
    currentY += 4;
    doc.text("En cas de retard de paiement, des pénalités sont exigibles sans rappel, calculées sur la base de trois fois le taux d’intérêt légal en vigueur.", marginLeft, currentY);
    currentY += 4;
    doc.text("Une indemnité forfaitaire de 40 € pour frais de recouvrement est également due, conformément aux articles L. 441-9, L. 441-10 et D. 441-5 du Code de commerce.", marginLeft, currentY);
    currentY += 4;
    if(data.before_payment) doc.text("La présente facture est émise avant encaissement, paiement attendu sous 14 jours à compter de la date d’émission.", marginLeft, currentY);
    else doc.text("La présente facture est émise après encaissement effectif des sommes dues.", marginLeft, currentY);
    


    doc.setDrawColor(80);
    doc.line(15, 47, 195, 47);
    doc.line(15, 89, 195, 89);
    

    doc.line(15,279,195,279);
    const text1 = "7 rue des Ormeaux, 49320 Les Garennes sur Loire - France";
    const text2 = "SARL au capital de 1000€ - TVA intracommunautaire : FR35939502464 - RCS Angers 939 502 464";

    const text1Width = doc.getTextWidth(text1);
    const text2Width = doc.getTextWidth(text2);
    doc.text(text1, (210 - text1Width) / 2, 285); 
    doc.text(text2, (210 - text2Width) / 2, 290)
    return doc;
};

export const slugify = (str:string) => {
  return str
    .toLowerCase()
    .normalize('NFD')               
    .replace(/[\u0300-\u036f]/g, '') 
    .replace(/'/g, '-')           
    .replace(/\s+/g, '-')    
    .replace(/[^a-z0-9-]/g, '')   
    .replace(/--+/g, '-')         
    .replace(/^-+|-+$/g, '');     
}
declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}
export const clickPhone = async (id_url:string,restoPhoneClicks:string[],setRestoPhoneClicks:Dispatch<SetStateAction<string[]>>,idrestaurant?:number) => {
    if (restoPhoneClicks.includes(id_url)) return;
    setRestoPhoneClicks([...restoPhoneClicks,id_url]);
    const IS_PROD_FR = window.location.host.endsWith('quelresto.fr');

    let hasAnalyticsConsent = false;
    try {
      const cookieConsent = document.cookie.split('; ').find(r => r.startsWith('QUELRESTO_COOKIE='));
      if (cookieConsent) {
        const cookieValue = decodeURIComponent(cookieConsent.split('=')[1]);
        const parsed = JSON.parse(cookieValue);
        hasAnalyticsConsent = !!parsed?.['perform-analytics'];
      }
    } catch { }
    if (
      IS_PROD_FR &&
      hasAnalyticsConsent &&
      typeof window.gtag === 'function' &&
      process.env.REACT_APP_TAG_ANALYSE_ADS &&
      process.env.REACT_APP_ADS_LABEL_PHONE  
    ) {
      window.gtag('event', 'conversion', {
        send_to: `${process.env.REACT_APP_TAG_ANALYSE_ADS}/${process.env.REACT_APP_ADS_LABEL_PHONE}`
      });
    }
    try {
        await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/updatePhoneClick`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ idrestaurant: idrestaurant }),
        });
        
    } catch (error) {
        console.error("Erreur lors de la connexion :", error);
    }
  
}
const atMidnight = (d: Date) => { const x = new Date(d); x.setHours(0,0,0,0); return x; };
const getMonday = (d: Date) => {
  const x = atMidnight(d);
  const day = x.getDay() || 7;
  if (day !== 1) x.setDate(x.getDate() - (day - 1));
  return x;
};
const getSunday = (d: Date) => {
  const mon = getMonday(d);
  const sun = new Date(mon);
  sun.setDate(mon.getDate() + 6);
  return sun;
};

export interface statsProps {
  averageSessionDuration:number,
  engagementRate: number,
  screenPageViews: number,
  totalUsers:number
}
export interface statsDatesProps {
  end:Date,
  start:Date,
  data:statsProps,
}
const NULL_WEEK:statsDatesProps = {
  start: new Date(),
  end:new Date(),
  data:{
  averageSessionDuration: -1,
  engagementRate: -1,
  screenPageViews: -1,
  totalUsers: -1,
  }
};
export function weekSlotsInCurrentMonth(today = new Date()): number {
  const y = today.getFullYear();
  const m = today.getMonth();

  const firstOfMonth = new Date(y, m, 1);
  const lastOfMonth  = new Date(y, m + 1, 0);

  const firstMonday  = getMonday(firstOfMonth);  
  const lastSunday   = getSunday(lastOfMonth);   

  const DAY_MS = 24 * 60 * 60 * 1000;
  const diffDaysInclusive =
    (atMidnight(lastSunday).getTime() - atMidnight(firstMonday).getTime()) / DAY_MS
    + 1;

  return Math.round(diffDaysInclusive / 7);
}
export function padWeeks(weeks: statsDatesProps[], target: number): statsDatesProps[] {
  const out = weeks.slice(0, target);
  while (out.length < target) out.push({ ...NULL_WEEK });
  return out;
}



export interface statsPointProps {
  percentTop:number,
  percentLeft:number,
  value:string,
  currentResa?:number,
  currentIncome?:number,
  currentCA?:number
}

export type trackingInfoProps = [number,number];

export type ClickStats = {
  year: string;
  month: string;
  week:number;
  clicks: string;
};

export const niceCeil = (n:number) => {
      if (!Number.isFinite(n) || n <= 0) return 0;
      const log = Math.floor(Math.log10(n));
      const base = Math.pow(10, log);
      return Math.ceil(n / base) * base;
    };
export const getNiceYAxisLabels = (maxValue: number, steps: number = 4): number[] => {
  const adjustedMax = maxValue * 1.15;
  const roughStep = adjustedMax / steps;
  const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));

  let baseSteps = [1, 2, 5, 10];
  if (magnitude >= 100) baseSteps = [1, 2, 5, 10, 20, 50];

  const niceStep = baseSteps.find(step => step * magnitude >= roughStep)! * magnitude;
  if(adjustedMax === 0 ) return baseSteps;
  const labels: number[] = [];
  for (let i = 0; i <= steps; i++) {
    const val = i * niceStep;
    if (val >= adjustedMax || i === steps) {
      labels.push(val);
      break;
    }
    labels.push(val);
  }

  return labels;
}

export const typemealMap: { [key: string]: number } = {
  "Brunch":0,
  "Déjeuner":1,
  "Dîner":2,
  "Buffet":3,
};
export const perfectforMap: { [key: string]: number } = {
  "En famille":0,
  "En famille avec enfants":1,
  "En couple":2,
  "Entre amis":3,
  "Avec soi-même":4,
  "Repas d’affaires":5,
  "Grandes occasions":6,
};

export interface UserModerationProps {
    photo:string,
    name:string,
    firstname:string,
    creation_date:Date,
    blamereview:number,
    id:number,
    biography:string
}
export interface RestaurateurModerationProps {
    idrestaurant:number,
    name:string,
    address:[string,string],
    published:boolean,
    monthoffert:number,
    id_url:string,
}
export const listReport = ["Il contient un langage grossier ou vulgaire" , "Il contient du contenu discriminatoire ou une incitation à la haine", "L'avis est mensonger ou faux", "Il a un contenu explicitement sexuel","Il est destiné à un autre établissement", "Il a été écrit par une personne affiliée à l'établissement","Autre raison"]

export const publicHolidays = [
  '01-01-2026', '06-04-2026', '01-05-2026', '08-05-2026',
  '14-05-2026', '25-05-2026', '14-07-2026', '15-08-2026',
];

export type Birth = { day: string; month: string; year: string };
export type ProfileBaseForm = { phone: string; postalCode: string; birth: Birth,emptyPhone:boolean,emptyBirth:boolean,emptyPostalCode:boolean,logGoogle:boolean };

export function useMediaQuery(query: string) {
  const [match, setMatch] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );
  useEffect(() => {
    const m = window.matchMedia(query);
    const onChange = () => setMatch(m.matches);
    m.addEventListener?.("change", onChange);
    return () => m.removeEventListener?.("change", onChange);
  }, [query]);
  return match;
}

export function cityWithPreposition(city:string) {
  const c = (city || '').trim();
  if (/^Les\s/i.test(c)) {
    return `aux ${c.replace(/^Les\s/i, '')}`; 
  }
  if (/^Le\s/i.test(c)) {
    return `au ${c.replace(/^Le\s/i, '')}`;   
  }
  if (/^La\s/i.test(c)) {
    return `à ${c}`;                        
  }
  if (/^L['’]/i.test(c)) {
    return `à ${c}`;
  }
  return `à ${c}`;  
}
export function cityWithOtherPreposition(cityWithPrep: string) {
  const c = (cityWithPrep || '').trim();

  if (/^aux\s/i.test(c)) {
    return `des ${c.replace(/^aux\s/i, '')}`;
  }
  if (/^au\s/i.test(c)) {
    return `du ${c.replace(/^au\s/i, '')}`;
  }
  if (/^à\s+l['’]/i.test(c)) {
    return `de l${c.replace(/^à\s+l/i, '')}`;
  }
  if (/^à\s+la\s/i.test(c)) {
    return `de la ${c.replace(/^à\s+la\s/i, '')}`;
  }
  if (/^à\s/i.test(c)) {
    const name = c.replace(/^à\s/i, '');
    return /^[aeiouâêîôûéèëïöüàä]/i.test(name)
      ? `d'${name}`
      : `de ${name}`;
  }
  return c;
}

export const faqBase = [[`Comment trouver un restaurant à proximité ou autour de moi`,'Pour trouver un restaurant à proximité, sélectionnez le filtre Distance (par défaut 10 km autour de vous). Vous pouvez aussi entrer le nom de votre ville dans la barre de recherche ou explorer la map QuelResto pour découvrir les restaurants autour de vous.'],
  ['Quels restaurants sont ouverts aujourd’hui, ce soir ou le dimanche','Pour savoir quels restaurants sont ouverts maintenant, ce midi, ce soir ou le dimanche, utilisez les icônes horloge et calendrier en haut de votre écran pour choisir une date et une heure. QuelResto affiche alors uniquement les restaurants correspondant à votre recherche, ce qui vous permet de trouver rapidement une table disponible quand vous en avez besoin.'],
  ['Quels sont les meilleurs restaurants selon les avis et les notes','Les meilleurs restaurants sur QuelResto sont mis en avant grâce à un algorithme qui prend en compte le nombre d’avis et la note moyenne de chaque établissement. Les restaurants les mieux notés apparaissent en haut des résultats, afin que vous puissiez repérer rapidement les adresses les plus appréciées selon les avis clients.'],
  ['Comment trouver un restaurant pas cher, romantique, avec terrasse, concrètement un restaurant adapté à mes envies ou à mes besoins','Pour trouver un restaurant pas cher, romantique, avec terrasse, un menu ouvrier ou répondant à une envie ou un besoin spécifique, utilisez la barre de filtres QuelResto. Vous pouvez par exemple sélectionner le budget, l’ambiance, un régime alimentaire (végétarien, végan, halal, sans gluten) ou des options pratiques comme l’accessibilité PMR ou le parking. L’ensemble des filtres disponibles vous permet ainsi de trouver facilement le restaurant le plus adapté à vos envies et à vos besoins.'],
  ['Où voir la carte, les photos et les avis d’un restaurant','Chaque restaurant dispose d’une page complète avec sa carte, ses photos, ses horaires et les avis clients. Un aperçu avec les photos, le prix moyen, la note et l’adresse est aussi visible dès la page d’accueil de QuelResto.'],
  ['Les avis des restaurants sur QuelResto sont-ils fiables et vérifiés','Tous les avis clients publiés sur QuelResto passent par une modération : nous retirons les contenus frauduleux ou inappropriés pour garantir des avis authentiques et utiles. À l’avenir, grâce à la réservation en ligne, il sera possible de laisser des avis 100 % vérifiés. Ces avis fiables vous permettent de comparer facilement les restaurants et de faire votre choix en toute confiance.'],
  ['Peut-on réserver un restaurant en ligne sur QuelResto','Sur chaque page restaurant, vous retrouvez une section réservation avec le numéro de téléphone du restaurant. Si l’établissement propose une réservation en ligne via son propre outil, un lien pour vous y rediriger est affiché. Plus tard, QuelResto intégrera sa propre réservation en ligne pour réserver rapidement et avoir des avis vérifiés. Vous pourrez ainsi réserver un restaurant en quelques clics, simplement et en toute confiance.'],
  ['Les informations des restaurants (horaires, prix, carte, photos, avis) sont-elles à jour sur QuelResto','Oui. Le prix moyen est calculé automatiquement à partir des données fournies et des avis récents. Les horaires, la carte et les photos sont mis à jour directement par les restaurateurs, avec la date de mise à jour affichée sur la carte et les horaires. Les avis clients indiquent toujours la date de publication, ce qui garantit des informations fiables et actualisées. Ainsi, vous avez l’assurance de consulter des restaurants avec des données à jour pour faire votre choix en toute confiance.']]
     
export const  faqProx = [['Comment trouver facilement un restaurant à proximité ou autour de moi','QuelResto utilise votre position pour afficher directement les restaurants à proximité. Vous pouvez aussi ajuster le filtre de distance pour élargir ou réduire la zone de recherche, ou saisir le nom d’une ville pour explorer ses restaurants et consulter leur carte, leur histoire et leurs photos.'],
  ['Quels restaurants à proximité sont ouverts aujourd’hui ou ce soir','Dans la barre de recherche en haut de page, vous pouvez sélectionner À proximité dans le champ ville. Avec les icônes calendrier et horloge, choisissez une date et une heure : cela vous permet de repérer facilement les restaurants à proximité ouverts aujourd’hui, ce midi, le soir ou le dimanche.'],
  ['Comment trouver un restaurant pas cher ou un menu ouvrier près de moi','Dans la barre de recherche, sélectionnez À proximité pour afficher les restaurants proches de vous. Grâce aux filtres, vous pouvez choisir un budget maximum ou activer l’option menu ouvrier. La liste met alors en avant les restaurants pas chers à proximité ou ceux qui proposent un menu ouvrier près de vous.'],
  ['Peut-on réserver un restaurant à proximité en ligne','Sur chaque page restaurant, une section réservation affiche le numéro de téléphone. Si l’établissement propose une réservation en ligne via son propre outil, un bouton de redirection est disponible. Bientôt, QuelResto intégrera sa propre réservation en ligne pour réserver directement un restaurant à proximité en quelques clics.']]


export function LineSeparationSVG({
    type = 0,
    thickness = 1,
    color = "#000000",
    wave = 0,        
    width = 80,    
    gradient = false,
    isMenu = true,
  }: {
    type:number;
    thickness: number;
    color: string;
    wave: number;
    width: number;
    gradient: boolean;
    isMenu?:boolean,
  }) {
    const W = 1000;
    const H = 1000;
  
    let w = Math.min(100, Math.max(10, width));
    let periods = (Math.round(5 + (w - 10) * (15 / 90)))*(isMenu ? 1 : 2);
    const A = (Math.max(0, Math.min(100, wave)) / 100) * (0.4 * H);
    const midY = H / 2;
    const step = W / periods;
  
    let d = `M 0 ${midY}`;
    for (let i = 0; i < periods; i++) {
      const x1 = i * step + step / 2;
      const x2 = (i + 1) * step;
      const up = i % 2 === 0 ? -A : A;
      d += ` Q ${x1} ${midY + up}, ${x2} ${midY}`;
    }
  
    const dashArray =
      type === 1
        ? `${thickness * 3} ${thickness * 2}` 
        : type === 2
        ? `${thickness} ${thickness * 2}`   
        : undefined;
  
    const linecap = type === 2 ? "round" : "butt";
  
  
    const gid = `grad-${Math.random().toString(36).slice(2)}`
  
    return (
      <svg
        width={`${width}%`}
        height={20}
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="none"
        style={{ display: "block" }}
      >
        {gradient && (
          <defs>
            <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%"   stopColor={color} stopOpacity="0" />
              <stop offset="15%"  stopColor={color} stopOpacity=".25" />
              <stop offset="50%"  stopColor={color} stopOpacity="1" />
              <stop offset="85%"  stopColor={color} stopOpacity=".25" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
        )}
  
        <path d={d} fill="none" stroke="transparent" strokeWidth={Math.max(10, thickness + 8)} />
  
        <path
          d={d}
          fill="none"
          stroke={gradient ? `url(#${gid})` : color}
          strokeWidth={thickness}          
          strokeDasharray={dashArray}
          strokeLinecap={linecap}
          vectorEffect="non-scaling-stroke" 
        />
      </svg>
    );
  }

const formatDateDailyMenu = (date:Date,isLower=false) => {
    const formatted = new Intl.DateTimeFormat("fr-FR", { weekday: "long", day: "numeric" }).format(date);
    return isLower ? formatted.charAt(0).toLocaleLowerCase() + formatted.slice(1) : formatted.charAt(0).toUpperCase() + formatted.slice(1); 
  };
export const getSentencesDailyMenu = (dateChoose:Date | null,scndDateChoose:Date | null) => {
    let isChooseToday = dateChoose ? (dateChoose.toDateString() === new Date().toDateString()) : false
    return dateChoose ? 
        (scndDateChoose ? (isChooseToday ? `Votre menu sera publié aujourd’hui jusqu’au ${formatDateDailyMenu(scndDateChoose,true)} (inclus).` : `Votre menu sera publié du ${formatDateDailyMenu(dateChoose,true)} jusqu’au ${formatDateDailyMenu(scndDateChoose,true)} (inclus).`)
            : (isChooseToday ? `Votre menu sera publié aujourd’hui jusqu’à 23h59.` : `Votre menu sera publié le ${formatDateDailyMenu(dateChoose,true)}.`)) 
        : 'Pour publier votre menu du jour, sélectionnez une date.'
}

export const listColor = ['#000000','#606060','#787878','#999799','#c0c0c0','#ffffff','#00167a','#0081cc','#2b51ff','#7a005f','#ac42ab','#cc008d','#007a3c','#48ac42','#00cc52','#d90404','#f07606',  '#e9c012'];
export const listColorBack = ['#000000','#787878','#a8a7a8','#c9c9c9','#ebebeb','#ffffff','#6d72b8','#70a1ce','#7ba4ff','#ae6db8','#ce70b4','#ffabdd','#6db872','#83ce70','#c6ffab','#ff6f6f','#f3a45c',  '#f9ffb2'];
export  const listGradient = [
      "linear-gradient(90deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 1) 50%, rgba(0, 0, 0, 0.50) 100%)",
      "linear-gradient(90deg, rgba(96, 96, 96, 0.50) 0%, rgba(96, 96, 96, 1) 50%, rgba(96, 96, 96, 0.50) 100%)",

      "linear-gradient(90deg, rgba(120, 120, 120, 0.50) 0%, rgba(120, 120, 120, 1) 50%, rgba(120, 120, 120, 0.50) 100%)",
      "linear-gradient(90deg, rgba(153, 151, 153, 0.50) 0%, rgba(153, 151, 153, 1) 50%, rgba(153, 151, 153, 0.50) 100%)",
      "linear-gradient(90deg, rgba(192, 192, 192, 0.50) 0%, rgba(192, 192, 192, 1) 50%, rgba(192, 192, 192, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.50) 100%)",

      "linear-gradient(90deg, rgba(0, 22, 122, 0.50) 0%, rgba(0, 22, 122, 1) 50%, rgba(0, 22, 122, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 129, 204, 0.50) 0%, rgba(0, 129, 204, 1) 50%, rgba(0, 129, 204, 0.50) 100%)",
      "linear-gradient(90deg, rgba(43, 81, 255, 0.50) 0%, rgba(43, 81, 255, 1) 50%, rgba(43, 81, 255, 0.50) 100%)",
      "linear-gradient(90deg, rgba(122, 0, 95, 0.50) 0%, rgba(122, 0, 95, 1) 50%, rgba(122, 0, 95, 0.50) 100%)",
      "linear-gradient(90deg, rgba(204, 0, 141, 0.50) 0%, rgba(204, 0, 141, 1) 50%, rgba(204, 0, 141, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 82, 186, 0.50) 0%, rgba(255, 82, 186, 1) 50%, rgba(255, 82, 186, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 122, 60, 0.50) 0%, rgba(0, 122, 60, 1) 50%, rgba(0, 122, 60, 0.50) 100%)",
      "linear-gradient(90deg, rgba(0, 204, 82, 0.50) 0%, rgba(0, 204, 82, 1) 50%, rgba(0, 204, 82, 0.50) 100%)",
      "linear-gradient(90deg, rgba(46, 255, 35, 0.50) 0%, rgba(46, 255, 35, 1) 50%, rgba(46, 255, 35, 0.50) 100%)",
      "linear-gradient(90deg, rgba(217, 4, 4, 0.50) 0%, rgba(217, 4, 4, 1) 50%, rgba(217, 4, 4, 0.50) 100%)",
      "linear-gradient(90deg, rgba(240, 118, 6, 0.50) 0%, rgba(240, 118, 6, 1) 50%, rgba(240, 118, 6, 0.50) 100%)",
      "linear-gradient(90deg, rgba(255, 216, 16, 0.50) 0%, rgba(255, 216, 16, 1) 50%, rgba(255, 216, 16, 0.50) 100%)",
  ];